<template>
    <section class="assets">
        <div v-if="hasAssets" class="assets__feed">
            <article class="assets-list-item" v-for="asset in assets" :key="asset.id">
                <span class="file file--small" :class="asset.type" />
                <p class="assets-list-item__title">{{ asset.original_name }}</p>
                <p class="assets-list-item__meta">{{ asset.size | formattedSize }}</p>
                <div class="assets-list-item__avatar">
                    <avatar :user="asset.author" />
                </div>
                <a :href="asset.url" class="icon-button" :download="asset.original_name">
                    <icon type="download" color="dark" size="18" />
                </a>
            </article>
        </div>
        <empty v-else type="photos" title="No uploads yet" subtitle="Why don't you add some?" />
    </section>
</template>

<script>
/* global Echo, app */
import { mapState } from 'vuex'
import Empty from '../Global/Empty'
import Icon from '../Global/Icon'
import Avatar from '../Global/Avatar'

export default {
    data () {
        return {
            isLoaded: false
        }
    },

    created () {
        Promise.all([
            this.$store.dispatch('job/fetchAssets')
        ]).then(() => {
            this.isLoaded = true
        })

        Echo.private(`${app.currentTenant.id}_job_${this.job.id}`)
            .listen('CommentWasCreated', (e) => {
                if (e.comment.attachment) {
                    this.$store.commit('job/ADD_ASSET', e.comment.attachment)
                }
            })
    },

    computed: {
        ...mapState('job', ['job', 'assets']),

        hasAssets () {
            return this.assets.length > 0
        }
    },

    components: {
        Empty,
        Icon,
        Avatar
    }
}
</script>
